<template>
    <div ref="scroller" class="listener-genres" @scroll.passive="rememberScroll">
        <section class="listener-genres__hero">
            <div class="listener-genres__header">
                <div>
                    <div class="listener-genres__eyebrow">{{ $tt('风格') }}</div>
                    <h1 class="listener-genres__title">{{ pageTitle }}</h1>
                </div>
                <button
                    class="listener-genres__refresh"
                    :disabled="loading"
                    :title="$tt('刷新')"
                    @click="refreshCurrentPage"
                >
                <svg t="1781507668775" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2332" width="250" height="250"><path d="M797.538462 699.648h-27.569231a319.744 319.744 0 0 0 61.873231-188.908308A320.157538 320.157538 0 0 0 512.059077 190.976a39.384615 39.384615 0 0 0-39.384615 39.384615 39.384615 39.384615 0 0 0 39.384615 39.384616 241.289846 241.289846 0 0 1 241.014154 240.994461 240.955077 240.955077 0 0 1-46.020923 141.469539v-44.228923a39.384615 39.384615 0 0 0-39.384616-39.384616 39.384615 39.384615 0 0 0-39.384615 39.384616v131.052307a39.384615 39.384615 0 0 0 39.384615 39.384616h129.969231a39.384615 39.384615 0 0 0 39.384615-39.384616 39.384615 39.384615 0 0 0-39.483076-39.384615z" fill="#333333" p-id="2333"></path><path d="M512 754.235077a241.250462 241.250462 0 0 1-240.994462-240.974769 240.817231 240.817231 0 0 1 46.020924-141.371077v38.006154a39.384615 39.384615 0 0 0 39.384615 39.384615 39.384615 39.384615 0 0 0 39.384615-39.384615V278.843077a39.384615 39.384615 0 0 0-39.384615-39.384615h-129.969231a39.384615 39.384615 0 0 0-39.384615 39.384615 39.384615 39.384615 0 0 0 39.384615 39.384615h32.393846a319.369846 319.369846 0 0 0-66.619077 194.953846 320.118154 320.118154 0 0 0 319.763693 319.744 39.384615 39.384615 0 0 0 39.384615-39.384615A39.384615 39.384615 0 0 0 512 754.235077z" fill="#333333" p-id="2334"></path></svg>

                </button>
            </div>

            <div class="listener-genres__tabs">
                <button
                    v-for="{ value, text } in options"
                    :key="value"
                    :class="['listener-genres__tab', sortValue === value ? 'is-active' : '']"
                    @click="switchSort(value)"
                >
                    {{ $tt(text) }}
                </button>
            </div>

            <div class="listener-genres__summary">
                <div class="listener-genres__summary-kicker">{{ $tt('当前视图') }}</div>
                <div class="listener-genres__summary-title">{{ pageTitle }}</div>
                <div class="listener-genres__summary-sub">{{ summaryText }}</div>
            </div>
        </section>

        <section v-if="items.length" class="listener-genres__section">
            <div class="listener-genres__grid">
                <article
                    v-for="item in items"
                    :key="item.id"
                    class="listener-genres__card"
                >
                    <button class="listener-genres__main" @click="openGenre(item)">
                        <img
                            :src="item.image || '/static/dist/img/album_null.jpg'"
                            :alt="item.name"
                            class="listener-genres__image"
                        >
                        <div class="listener-genres__name">{{ item.name }}</div>
                        <div class="listener-genres__meta">
                            <span>{{ $tt('{count} 张专辑', { count: item.albumCount || 0 }) }}</span>
                            <span>{{ $tt('{count} 首歌曲', { count: item.trackCount || 0 }) }}</span>
                        </div>
                    </button>
                    <button class="listener-genres__play" @click.stop="playNow(item.id)">
                        <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M8 5.14v13.72a1 1 0 0 0 1.5.86l10-6.86a1 1 0 0 0 0-1.72l-10-6.86A1 1 0 0 0 8 5.14z"></path>
                        </svg>
                    </button>
                </article>
            </div>
        </section>

        <section v-else-if="!loading" class="listener-genres__empty">
            <div class="listener-genres__empty-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8">
                    <path d="M12 3c4.97 0 9 3.134 9 7s-4.03 7-9 7-9 3.134-9 7"></path>
                    <path d="M12 3c-4.97 0-9 3.134-9 7s4.03 7 9 7 9 3.134 9 7"></path>
                </svg>
            </div>
            <h2>{{ $tt('这里还没有风格') }}</h2>
            <p>{{ $tt('当前排序下暂时没有可浏览的内容。') }}</p>
        </section>

        <section v-if="loading" class="listener-genres__state">
            <div class="listener-genres__loading"></div>
            <p>{{ $tt('正在加载...') }}</p>
        </section>
    </div>
</template>

<script>
export default {
    name: 'ListenerGenreLibrary',
    data() {
        return {
            loading: true,
            items: [],
            curScrollTop: 0,
            options: [
                { text: 'A-Z排序', value: 'a-z' },
                { text: '最多专辑', value: 'most-albums' },
                { text: '最多歌曲', value: 'most-tracks' }
            ]
        }
    },
    computed: {
        sortValue() {
            return this.$route.params.sort || 'a-z'
        },
        pageTitle() {
            const current = this.options.find(item => item.value === this.sortValue)
            return current ? this.$tt(current.text) : this.$tt('风格列表')
        },
        summaryText() {
            const map = {
                'a-z': this.$tt('按名称慢慢翻，适合直接找某个熟悉的风格。'),
                'most-albums': this.$tt('优先展示专辑量更多的风格，更适合整批浏览。'),
                'most-tracks': this.$tt('优先展示歌曲更多的风格，适合快速开播。')
            }
            return map[this.sortValue] || this.$tt('从不同维度浏览你的风格收藏。')
        }
    },
    created() {
        this.fetchGenres()
    },
    activated() {
        this.$nextTick(() => {
            if (this.$refs.scroller) {
                this.$refs.scroller.scrollTop = this.curScrollTop || 0
            }
        })
    },
    methods: {
        async refreshCurrentPage() {
            if (this.loading) {
                return
            }
            this.curScrollTop = 0
            if (this.$refs.scroller) {
                this.$refs.scroller.scrollTop = 0
            }
            return this.fetchGenres()
        },
        async fetchGenres() {
            this.loading = true
            try {
                this.items = await this.$api.subsonic.getGenres(this.sortValue)
            } finally {
                this.loading = false
            }
        },
        async playNow(id) {
            const genre = await this.$api.subsonic.getTracksByGenre(id, 100)
            return this.$store.dispatch('playTrackList', {
                tracks: genre
            })
        },
        openGenre(item) {
            this.$router.push({ name: 'genre', params: { id: item.id } })
        },
        rememberScroll() {
            if (this.$refs.scroller) {
                this.curScrollTop = this.$refs.scroller.scrollTop
            }
        },
        switchSort(value) {
            if (value === this.sortValue) {
                return
            }
            this.$router.push({ path: '/genres/' + value })
        }
    }
}
</script>

<style scoped>
.listener-genres {
    height: calc(100dvh - 12.25rem);
    padding: 0.45rem 0.1rem 0.25rem;
    box-sizing: border-box;
    overflow-y: auto;
}

.listener-genres__hero {
    padding: 0.3rem 0.25rem 0.2rem;
}

.listener-genres__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 1rem;
    margin-bottom: 1rem;
}

.listener-genres__eyebrow {
    font-size: 0.85rem;
    font-weight: 700;
    color: #94a3b8;
    letter-spacing: 0.04em;
}

.listener-genres__title {
    margin-top: 0.2rem;
    font-size: 2rem;
    line-height: 1;
    font-weight: 800;
    color: #111827;
    letter-spacing: -0.04em;
}

.listener-genres__refresh {
    width: 2.8rem;
    height: 2.8rem;
    border: 0;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.84);
    color: #0f172a;
    box-shadow: 0 12px 26px rgba(148, 163, 184, 0.14);
}

.listener-genres__refresh:disabled {
    opacity: 0.6;
}

.listener-genres__refresh svg {
    width: 2rem;
    height: 1.5rem;
}

.listener-genres__tabs {
    display: flex;
    gap: 0.55rem;
    overflow-x: auto;
    padding-bottom: 0.15rem;
    scrollbar-width: none;
}

.listener-genres__tabs::-webkit-scrollbar {
    display: none;
}

.listener-genres__tab {
    border: 0;
    border-radius: 999px;
    padding: 0.72rem 0.9rem;
    white-space: nowrap;
    background: rgba(255, 255, 255, 0.85);
    color: #64748b;
    font-size: 0.84rem;
    font-weight: 700;
    box-shadow: 0 10px 24px rgba(148, 163, 184, 0.1);
}

.listener-genres__tab.is-active {
    background: #111827;
    color: #fff;
    box-shadow: 0 16px 30px rgba(15, 23, 42, 0.2);
}

.listener-genres__summary {
    margin-top: 0.95rem;
    padding: 1rem;
    border-radius: 1.65rem;
    background: linear-gradient(135deg, rgba(17, 24, 39, 0.96), rgba(55, 65, 81, 0.92));
    color: #fff;
    box-shadow: 0 20px 46px rgba(15, 23, 42, 0.16);
}

.listener-genres__summary-kicker {
    font-size: 0.72rem;
    color: rgba(255,255,255,0.68);
}

.listener-genres__summary-title {
    margin-top: 0.35rem;
    font-size: 1.38rem;
    font-weight: 800;
    line-height: 1.15;
}

.listener-genres__summary-sub {
    margin-top: 0.45rem;
    font-size: 0.82rem;
    line-height: 1.7;
    color: rgba(255,255,255,0.74);
}

.listener-genres__section {
    margin-top: 1.1rem;
}

.listener-genres__grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 0.9rem;
}

.listener-genres__card {
    position: relative;
    border-radius: 1.55rem;
    padding: 0.85rem;
    background: rgba(255, 255, 255, 0.78);
    box-shadow: 0 12px 28px rgba(148, 163, 184, 0.1);
}

.listener-genres__main {
    width: 100%;
    border: 0;
    padding: 0;
    background: transparent;
    text-align: left;
}

.listener-genres__image {
    width: 100%;
    aspect-ratio: 1 / 1;
    object-fit: cover;
    border-radius: 1.2rem;
}

.listener-genres__name {
    margin-top: 0.75rem;
    font-size: 0.95rem;
    font-weight: 800;
    color: #111827;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.listener-genres__meta {
    margin-top: 0.28rem;
    display: flex;
    flex-direction: column;
    gap: 0.15rem;
    font-size: 0.76rem;
    color: #94a3b8;
}

.listener-genres__play {
    position: absolute;
    right: 1rem;
    bottom: 3.3rem;
    width: 2.7rem;
    height: 2.7rem;
    border: 0;
    border-radius: 999px;
    background: #111827;
    color: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 16px 30px rgba(15, 23, 42, 0.18);
}

.listener-genres__play svg {
    width: 1.1rem;
    height: 1.1rem;
}

.listener-genres__empty,
.listener-genres__state {
    margin-top: 1.2rem;
    padding: 2rem 1.25rem;
    border-radius: 1.6rem;
    background: rgba(255,255,255,0.78);
    text-align: center;
    color: #64748b;
    box-shadow: 0 12px 28px rgba(148, 163, 184, 0.08);
}

.listener-genres__empty h2 {
    margin-top: 0.75rem;
    font-size: 1.05rem;
    font-weight: 800;
    color: #111827;
}

.listener-genres__empty p,
.listener-genres__state p {
    margin-top: 0.35rem;
    font-size: 0.84rem;
    line-height: 1.65;
}

.listener-genres__empty-icon {
    width: 3.25rem;
    height: 3.25rem;
    margin: 0 auto;
    border-radius: 999px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background: rgba(226, 232, 240, 0.72);
    color: #475569;
}

.listener-genres__empty-icon svg {
    width: 1.5rem;
    height: 1.5rem;
}

.listener-genres__loading {
    width: 2.35rem;
    height: 2.35rem;
    margin: 0 auto;
    border-radius: 999px;
    border: 3px solid rgba(148, 163, 184, 0.2);
    border-top-color: #111827;
    animation: listener-genre-spin 0.9s linear infinite;
}

@keyframes listener-genre-spin {
    to {
        transform: rotate(360deg);
    }
}
</style>
